import React from 'react';
import { about } from '../../models/content';
import V2CtaDark from '../components/V2CtaDark';

export default function V2AboutPage() {
  return (
    <>
      <main>
        <section className="page-hero">
          <div className="wrap">
            <span className="v2-badge">
              <span className="dot" />
              {about.heroBadge}
            </span>
            <h1>
              {about.heroTitle.map((p, i) =>
                typeof p === 'string' ? (
                  <React.Fragment key={i}>{p}</React.Fragment>
                ) : (
                  <span key={i} className="it">
                    {p.it}
                  </span>
                )
              )}
            </h1>
            <p className="sub">{about.heroSub}</p>
          </div>
        </section>

        <section>
          <div className="wrap">
            <div className="prose">
              <p>{about.intro}</p>
              <p>
                Capri Stressed Assets Fund (CSAF) focuses on investing in Indian mid-market special situation
                opportunities involving 1) stressed companies with strong underlying businesses and 2) acquisition
                funding. We work closely with existing / strategic sponsor(s) and provide a complete capital solution
                through debt and equity and work towards turnaround strategies for maximising value for stakeholders.
                The Fund has a target corpus of <strong>₹1,000 crore</strong> with an additional{' '}
                <strong>₹500 crore</strong> green-shoe option. It has received commitments of{' '}
                <strong>₹736 crore</strong> as of the end of May 2026 and is expected to complete its final close on{' '}
                <strong>7 November 2026</strong>. The Sponsor, affiliates, and partners have committed{' '}
                <strong>₹450 crore</strong>, underscoring strong alignment with investors. We are targeting a gross IRR
                of <strong>25%</strong>. The target is based on Manager’s underwriting assumptions and is not a forecast,
                projection, guarantee or assurance of future performance. The Fund’s remaining life is{' '}
                <strong>7 years</strong> from final close.
              </p>
              <p className="lift">
                Our primary focus is to work with companies having{' '}
                <strong>‘Good Businesses with Bad Balance Sheets’</strong>
                {' '}in the mid-market segment.
              </p>
            </div>
          </div>
        </section>
      </main>

      <V2CtaDark />
    </>
  );
}
